/** Stand-in for a route tree the current build does not ship. */
export default function emptyRouteTree() {
  return null;
}
